import React, { useState } from 'react';
import { Tab, Tabs, TabList, TabPanel, TabPanels, Box } from '@chakra-ui/react';
import CustomerBalance from './customerbalance';
import CustomerInvoice from './customerinvoice';
import CustomerAdvances from './customeradvances';

const Customer = () => {

	const [tabIndex, setTabIndex] = useState(0);

	const handleSwitchToAdvance = () => {
		setTabIndex(2); // Index of 'Customer Advances' tab
	};

	return (
		<Box w='100%'>
			<Tabs
				index={tabIndex}
				onChange={(index) => setTabIndex(index)}
				bg='white'
				boxShadow='md'
				border='none'
				borderRadius='0px 0px 5px 5px'
				size='lg'
				isManual
				variant='enclosed'>
				<TabList
					bg='var(--chakra-colors-mainBlueColor)'
					boxShadow='0px 4px 4px rgba(0, 0, 0, 0.25)'
					color='white'
					padding='10px 15px'>
					<Tab
						_selected={{
							color: 'var(--chakra-colors-mainBlueColor)',
							bg: 'white',
						}}
						fontSize='1.4rem'
						borderRadius='5px'
						fontWeight='600'>
						Customer Balance
					</Tab>
					<Tab
						_selected={{
							color: 'var(--chakra-colors-mainBlueColor)',
							bg: 'white',
						}}
						fontSize='1.4rem'
						borderRadius='5px'
						fontWeight='600'>
						Customer Invoice
					</Tab>
					<Tab
						isDisabled
						_selected={{
							color: 'white',
							bg: 'green',
						}}
						fontSize='1.4rem'
						borderRadius='5px'
						fontWeight='600'>
						Customer Advances
					</Tab>
				</TabList>

				<TabPanels>
					<TabPanel>
						<CustomerBalance />
					</TabPanel>
					<TabPanel>
						<CustomerInvoice onAdvanceClick={handleSwitchToAdvance} />
					</TabPanel>
					<TabPanel>
						<CustomerAdvances />
					</TabPanel>
				</TabPanels>
			</Tabs>
		</Box>
	);
};

export default Customer;
